import { Button } from '@creditornot/cb-button';
import { colors, cssThemedValue, Typography as T } from '@creditornot/cb-ingredients';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { getLatestKycProcess } from 'apis/legitimizer/kyc/api';
import { getErrorMessageKey } from 'apis/legitimizer/kyc/utils';
import MagnifyingGlasses from 'common/illustrations/MagnifyingGlasses';

import { CenteredRoot, Heading, TextStack } from '../ComplianceContent';
import { BREAKPOINT_MOBILE } from '../breakpoints';

const StyledIllustration = styled(MagnifyingGlasses)`
  height: 213px;
  width: 320px;
`;

const StyledBody = styled(T.Body1)`
  text-align: center;
  max-width: 400px;
`;

const StyledErrorMessageBody = styled(T.Body1)`
  background: ${cssThemedValue({ light: colors.pepper4, dark: colors.salt12 })};
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  width: 100%;
  max-width: 524px;
`;

const StyledButton = styled(Button)`
  width: 100%;

  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    max-width: 200px;
  }
`;

const RetryPage = () => {
  const history = useHistory();

  const handleContinue = () => {
    history.push('/identity-verification/intro');
  };

  const { data: latestProcess } = useQuery(['kyc/processes/latest'], () => getLatestKycProcess(), {
    retry: false,
  });

  const error = latestProcess?.error;
  const hasKnownError = !!error && error.key !== 'unknown';

  return (
    <CenteredRoot>
      <StyledIllustration />
      <TextStack>
        <Heading>
          <FormattedMessage id="compliance.kyc.retry.heading" />
        </Heading>

        {hasKnownError && (
          <StyledErrorMessageBody>
            <FormattedMessage id={getErrorMessageKey(error)} />
          </StyledErrorMessageBody>
        )}

        <StyledBody>
          <FormattedMessage id="compliance.kyc.retry.body" />
        </StyledBody>
      </TextStack>

      <StyledButton size="large" variant="blue" onClick={handleContinue}>
        <FormattedMessage id="compliance.kyc.retry.continue" />
      </StyledButton>
    </CenteredRoot>
  );
};

export default RetryPage;
